<page-toolbar [pageActions]="pageActions" [title]="title"></page-toolbar>

<page-content>
  <data-table (edit)="onEdit($event)"
                  (remove)="onRemove($event)"
                  [columns]="columns"
                  [dataProvider]="organisationService"
                  [title]="title">
  </data-table>

</page-content>
